// @ts-nocheck
import type { Settings as LayoutSettings } from '@ant-design/pro-components';
import type { RunTimeLayoutConfig } from '@umijs/max';
import { history } from '@umijs/max';
import { Avatar, Dropdown, Menu } from 'antd';
import React from 'react';
import defaultSettings from '../config/defaultSettings';
import { currentUser } from '@/services/aqua-link-platform/api';
import '@/styles/mobile.less';

const loginPath = '/user/login';

export async function getInitialState() {
  // 没有 token：返回未登录状态，交给 onPageChange 守卫跳转登录页（不伪造 token）
  if (!localStorage.getItem('token')) {
    return {
      settings: defaultSettings,
    };
  }

  // 尝试从API获取当前用户信息
  try {
    const response = await currentUser();
    if (response && response.data) {
      return {
        settings: defaultSettings,
        currentUser: {
          id: response.data.id,
          username: response.data.username,
          name: response.data.username,
          email: response.data.email,
          role: response.data.role,
          status: response.data.status
        },
      };
    }
  } catch (error: any) {
    console.warn('无法从API获取用户信息:', error);
  }

  // token 失效或接口异常：清掉本地登录态，交给守卫跳转登录页重新登录
  localStorage.removeItem('token');
  localStorage.removeItem('user');
  return {
    settings: defaultSettings,
  };
}

// 自定义页脚组件 - 固定在底部正中间
const CustomFooter = () => {
  return (
    <div style={{
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      textAlign: 'center',
      padding: '16px 0',
      color: 'rgba(0, 0, 0, 0.45)',
      fontSize: '14px',
      borderTop: '1px solid #f0f0f0',
      backgroundColor: '#fff',
      zIndex: 100
    }}>
      © 2026 上海渠观工程设计咨询有限公司
    </div>
  );
};


export const layout: RunTimeLayoutConfig = ({ initialState }) => {
  return {
    footerRender: () => <CustomFooter />,
    onPageChange: () => {
      const { location } = history;
      // 如果没有登录，重定向到 login
      if (!initialState?.currentUser && location.pathname !== loginPath) {
        history.push(loginPath);
      }
    },
    menuHeaderRender: undefined,
    rightRender: () => {
      if (!initialState?.currentUser) {
        return null;
      }

      const menu = (
        <Menu>
          <Menu.Item key="1" onClick={() => {
            history.push('/user/profile');
          }}>
            个人中心
          </Menu.Item>
          <Menu.Item key="2" onClick={() => {
            localStorage.removeItem('token');
            history.push(loginPath);
            window.location.reload();
          }}>
            退出登录
          </Menu.Item>
        </Menu>
      );

      return (
        <Dropdown overlay={menu} placement="bottomRight">
          <div style={{ display: 'flex', alignItems: 'center', marginRight: 24, cursor: 'pointer' }}>
            <Avatar style={{ marginRight: 8 }}>{initialState.currentUser.name.charAt(0)}</Avatar>
            <span>{initialState.currentUser.name}</span>
          </div>
        </Dropdown>
      );
    },
    ...initialState?.settings,
  };
};
